import { render, staticRenderFns } from "./DetailChart.vue?vue&type=template&id=f72990aa&scoped=true&"
import script from "./DetailChart.vue?vue&type=script&lang=js&"
export * from "./DetailChart.vue?vue&type=script&lang=js&"
import style0 from "./DetailChart.vue?vue&type=style&index=0&id=f72990aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72990aa",
  null
  
)

export default component.exports